import type { FocusableElement } from "@react-types/shared";
import type { RefObject } from "react";
import { type TooltipTriggerProps, useTooltipTrigger } from "react-aria";
import { useTooltipTriggerState } from "react-stately";

export const useTooltip = (triggerRef: RefObject<FocusableElement | null>, options: TooltipTriggerProps = {}) => {
  const state = useTooltipTriggerState(options);
  const { triggerProps, tooltipProps } = useTooltipTrigger(options, state, triggerRef);

  return { triggerProps, tooltipProps, state };
};
